//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const pageSuccess = ref(1)
    const pageError = ref(2)
    const pageInfo = ref(3)

    return { pageSuccess, pageError, pageInfo }
  },
}
